import React, { useEffect, useState } from "react";
import "../styles/cursor.css";

export default function Cursor() {
  const [pos, setPos] = useState({ x: 0, y: 0 });
  const [hover, setHover] = useState(false);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);

  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth > 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (!isDesktop) return; // don’t track events on mobile

    const move = (e) => setPos({ x: e.clientX, y: e.clientY });
    const handleHover = (e) => {
      const target = e.target;
      if (target.closest("a, button")) {
        setHover(true);
      } else {
        setHover(false);
      }
    };

    window.addEventListener("mousemove", move);
    window.addEventListener("mouseover", handleHover);

    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseover", handleHover);
    };
  }, [isDesktop]);

  // 🚫 On mobile, render nothing
  if (!isDesktop) return null;

  return (
    <div
      className={`cursor ${hover ? "hovering" : ""}`}
      style={{ left: `${pos.x}px`, top: `${pos.y}px` }}
    >
      <div className="cursor-dot"></div>
      <div className="cursor-ring"></div>
    </div>
  );
}
